// import { useCallback } from "react";
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { NotifyLuckEarned } from '../../../types/lives/notifies'

const LIVE_LUCK_EARNED_USER = '/LIVE-LUCK-EARNED-USER'

export const useUpdateReturnValueLuck = () => {
  const myUserId = useGlobalStore(
    useShallow((state) => {
      return state.myUserId
    }),
  )

  const addNotifyGiftLuck = useGlobalStore(
    useShallow((state) => {
      return state.addNotifyGiftLuck
    }),
  )

  useSub<NotifyLuckEarned>({
    endpoint: `${LIVE_LUCK_EARNED_USER}/${myUserId}`,
    skip: !myUserId,
    onData: addNotifyGiftLuck,
  })
}
